import React, {useContext} from "react";
import "../../styles/welcome-page/style.css";
import "../../styles/welcome-page/styleguide.css";
import logo from "../../images/welcome-page/logo.svg";
import subtract from "../../images/welcome-page/subtract.svg";
import subtract1 from "../../images/welcome-page/subtract-1.svg";
import subtract2 from "../../images/welcome-page/subtract-2.svg";
import subtract3 from "../../images/welcome-page/subtract-3.svg";
import AuthContext from "../../contexts/AuthContext";

export default function WelcomeScreen ({handleStartClick}) {
    const {onLogout} = useContext(AuthContext);
    return (
        <div className="welcome-screen">
            <div className="frame">
                <div style={{display: "flex", alignItems: "center", gap: "1rem"}}>
                    <img className="img" alt="Frame" src={logo}/>

                    <button className="button" onClick={(e) => {
                        e.preventDefault();
                        window.open('https://www.carbonsolutionsgroup.com/contact/', '_blank');
                    }}>
                        <div className="label">Contact Us</div>
                    </button>
                </div>

                <button onClick={onLogout} className="ms-auto">Logout</button>
            </div>

            <div className="overlap-wrapper">
                <div className="overlap">
                    <div className="overlap-group">
                        <div className="frame-2">
                            <div className="frame-wrapper">
                                <div className="div-wrapper">
                                    <div className="text-wrapper">Welcome to CSG</div>
                                </div>
                            </div>

                            <p className="p">
                                This portal is your all-in-one tool for managing your Renewable
                                Energy Credit (REC) participation with Carbon Solutions Group
                            </p>
                        </div>

                        <div className="frame-3">
                            <div className="frame-4">
                                <div className="frame-5">
                                    <div className="group">
                                        <img className="subtract" alt="Subtract" src={subtract}/>
                                    </div>

                                    <div className="frame-6">
                                        <div className="text-wrapper-2">
                                            Review &amp; Sign Contract
                                        </div>

                                        <p className="text-wrapper-3">
                                            Before proceeding, please complete and sign your
                                            agreement. This step is required to move forward.
                                        </p>
                                    </div>
                                </div>

                                <div className="frame-7">
                                    <div className="group">
                                        <img className="subtract-1" alt="Subtract" src={subtract1}/>
                                    </div>

                                    <div className="frame-6">
                                        <div className="text-wrapper-2">Track Your Application</div>

                                        <p className="text-wrapper-3">
                                            Stay updated on the status of your REC application in real
                                            time.
                                        </p>
                                    </div>
                                </div>

                                <div className="frame-7">
                                    <div className="group">
                                        <img className="subtract-2" alt="Subtract" src={subtract2}/>
                                    </div>

                                    <div className="frame-6">
                                        <div className="text-wrapper-2">Monitor Your Payments</div>

                                        <p className="text-wrapper-3">
                                            View payment history and upcoming disbursements.
                                        </p>
                                    </div>
                                </div>

                                <div className="frame-7">
                                    <div className="group">
                                        <img
                                            className="subtract-3"
                                            alt="Subtract"
                                            src={subtract3}
                                        />
                                    </div>

                                    <div className="frame-6">
                                        <div className="text-wrapper-2">Enroll in ACH Payments</div>

                                        <p className="text-wrapper-3">
                                            Sign up for direct deposit to receive your payments faster
                                            and more securely.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="frame-8">
                            <button className="label-wrapper" onClick={handleStartClick}>
                                <div className="label-2">Click to Get Started</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="frame-9">
                <p className="text-wrapper-4">All Rights Reserved © 2024</p>

                <div className="frame-10">
                    <div className="title-default">
                        <a
                            href="https://www.carbonsolutionsgroup.com/privacy-policy/"
                            target="_blank"
                            rel="noreferrer">Privacy Policy</a>
                    </div>
                    <div className="title-default">
                        <a
                            href="https://www.carbonsolutionsgroup.com/terms-conditions/"
                            target="_blank"
                            rel="noreferrer">Terms and Conditions</a
                    ></div>
                </div>
            </div>
        </div>
    );
};
